/* eslint-disable no-unused-vars */
import React from 'react';
import _ from 'lodash';

import Icon from '@components/icon-component';

import style from './filter-header.module.scss';

const FilterHeader = ({
  title,
  filterCount,
  resetBtnEvent,
  leftBtnEvent,
  siteListingWhenMapsIsOpenOnTabletScreen = false,
  openBookmarkModalEvent,
  bookmarkId = null,
  isFilterChangedInBookmark = null,
  width,
  detailPage = false,
  mapView = false
}) => {
  return (
    <>
      {siteListingWhenMapsIsOpenOnTabletScreen ? (
        <div className={style.header}>
          <div className={style.flex1}>
            <div className={`${style.divBar}`} id="div-bar" />
            {title && <p className={style.p}>{title}</p>}
          </div>
        </div>
      ) : (
        <div className={style.header}>
          <div className={style.flex}>
            {mapView ? (
              <>
                {!siteListingWhenMapsIsOpenOnTabletScreen && (
                  <div className={style.iconClass}>
                    <Icon name={filterCount > 0 ? 'blue-filter' : 'filter-black'} />
                    {filterCount > 0 && <span>{filterCount}</span>}
                  </div>
                )}
                <div className={`${style.divBar}`} id="div-bar" />
                {title && <p className={style.p}>{title}</p>}
              </>
            ) : (
              <>
                {width <= 767 && <div className={`${style.divBar}`} id="div-bar" />}
                {title && (
                  <>
                    <p
                      className={`${style.p} ${width <= 767 && !detailPage && style.bookmarkIcon} `}
                    >
                      {width <= 767 && !detailPage && <span></span>}
                      <span>{title}</span>

                      {width <= 767 && !detailPage && (
                        <Icon
                          name={
                            isFilterChangedInBookmark
                              ? 'bookmarker-but-edited'
                              : bookmarkId
                              ? 'bookmarked-name'
                              : 'not-bookmarked'
                          }
                          onClick={openBookmarkModalEvent}
                        />
                      )}
                    </p>
                  </>
                )}
              </>
            )}
          </div>
          <div className={style.flexRight}>
            {/* {filterCount > 0 && <button onClick={resetBtnEvent}>RESET</button>} */}
            {leftBtnEvent && (
              <>
                {!detailPage && (
                  <Icon
                    name={
                      isFilterChangedInBookmark
                        ? 'bookmarker-but-edited'
                        : bookmarkId
                        ? 'bookmarked-name'
                        : 'not-bookmarked'
                    }
                    onClick={openBookmarkModalEvent}
                  />
                )}
                <Icon name={'hide-filter'} onClick={leftBtnEvent} />
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(FilterHeader, _.isEqual);
